import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import CSSModules from "lib/utils/css-modules";
import bind from "memoize-bind";

import { Link, Button, Dropdown, st } from "lib/index";
import { logout } from "modules/auth";
import { pushRoute, toggleLeftBar, toggleSidebar } from "modules/app/actions";
import { open as openNewOrderModal } from "modules/orders/NewOrderModal";
import styles from "./TopBar.less";

@connect(
  (state) => ({
    currentUserFullName: state.auth.user.full_name,
    currentCompany: state.auth.company.model,
    currentCompanyId: state.auth.companyId,
    leftBarToggleForced: state.app.leftBarToggleForced,
    sidebarVisible: state.app.sidebarVisible,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        logout,
        toggleLeftBar,
        toggleSidebar,
        openNewOrderModal,
        pushRoute,
      },
      dispatch
    )
)
@withRouter
@CSSModules(styles)
export default class TopBar extends React.PureComponent {
  handleLogoutClick() {
    const { logout, pushRoute } = this.props;
    logout({ revokeToken: true });
    pushRoute("/login");
  }

  canToggleSidebar() {
    const { router, currentCompanyId } = this.props;
    const sidebarPaths = ["affiliate", "customers", "finances", "orders", "products"].map(
      (suffix) => `/c/${currentCompanyId}/${suffix}`
    );
    return sidebarPaths.some((path) => router.isActive(path));
  }

  render() {
    const {
      currentUserFullName,
      currentCompany,
      currentCompanyId,
      leftBarToggleForced,
      sidebarVisible,
      toggleLeftBar,
      toggleSidebar,
      openNewOrderModal,
    } = this.props;

    const userLink = (
      <a className={styles["link-user"]}>
        <img src="/images/placeholder-user.png" />
        {currentUserFullName}
        <i className="icon dropdown" />
      </a>
    );

    const _url =
      currentCompany &&
      currentCompany.getMarketplaceHomepageUrl() &&
      currentCompany.getMarketplaceHomepageUrl().split("old.").join("");
    return (
      <div styleName="container">
        <div styleName="items-left">
          {leftBarToggleForced === null && (
            <div styleName="item">
              <a styleName="link-menu" onClick={bind(toggleLeftBar, null, undefined, undefined)}>
                <i className="icon material-icons">menu</i>
              </a>
              {this.canToggleSidebar() && (
                <a
                  styleName="link-menu"
                  onClick={bind(toggleSidebar, null)}
                  title={I18n.t(sidebarVisible ? "papp.common.hide_filters" : "papp.common.show_filters")}
                >
                  <i className="icon material-icons">filter_list</i>
                </a>
              )}
            </div>
          )}
        </div>

        {currentCompany && currentCompany.test_mode && <div className={styles["test-mode"]}>test mode</div>}

        <form styleName="search" hidden>
          <i styleName="search-icon" className="material-icons">
            search
          </i>
          <input type="search" styleName="search-input" placeholder={I18n.t("papp.common.search")} />
        </form>
        <div styleName="items-right">
          {currentCompany && !currentCompany.reseller && currentCompany.getMarketplaceHomepageUrl() && (
            <div styleName="item">
              <div styleName="link-button">
                <Button
                  as="a"
                  size="tiny"
                  href={_url}
                  target="_blank"
                  content={I18n.t("papp.app.TopBar.marketplace_homepage")}
                />
              </div>
            </div>
          )}
          {currentCompany && currentCompany.saas_url && (
            <div styleName="item">
              <div styleName="link-button">
                <Button
                  as="a"
                  size="tiny"
                  href={currentCompany.getHomepageUrl()}
                  target="_blank"
                  content={I18n.t("papp.app.TopBar.saas_homepage")}
                />
              </div>
            </div>
          )}
          {currentCompany && (currentCompany.enable_saas || currentCompany.is_st) && (
            <div styleName="item">
              <div styleName="link-button">
                <Button
                  as="a"
                  size="tiny"
                  onClick={bind(openNewOrderModal, null, undefined)}
                  content={I18n.t("papp.app.TopBar.new_order")}
                />
              </div>
            </div>
          )}
          <div styleName="item-sep" />
          <div styleName="item">
            <Dropdown icon={null} trigger={userLink} fluid>
              <Dropdown.Menu
                style={{
                  position: "fixed",
                  right: 0,
                  left: "auto",
                  top: "100%",
                }}
              >
                <Dropdown.Item
                  as={Link}
                  to={`/c/${currentCompanyId}/settings/user/account`}
                  text={I18n.t("papp.app.TopBar.your_account")}
                />
                <Dropdown.Item onClick={bind(this.handleLogoutClick, this)} text={I18n.t("papp.app.TopBar.logout")} />
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/TopBar.jsx